import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Country, State } from 'country-state-city';
import { Checkbox, Form, Input, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { FormHeader, FormItem, FormSubmitButtonConatainer, RowWrapper } from 'component/form_component/style';
import { createChildOuData } from 'redux/slices/getChildOu';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { CreateContendwrap, CreateFormwrap, CreateStyleDiv, Createwrap } from './style';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { useRefreshOuTab } from 'component/table_component/ou_data/refreshOuData';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { addOuInAdminTree } from 'redux/slices/treedata';
import { addOuInOuAdminTree } from 'redux/slices/ouAdminTree';
import { refreshToken } from 'redux/slices/authSlice';

export default function CreateChildOU() {
  const refreshOuTab = useRefreshOuTab();
  const selectedNode = useSelector((state) => state.selectedNode);
  const { nodeKey } = useSelector((state) => state.treeData);
  const { ouAdminNodeKey } = useSelector((state) => state.ouTreeData);
  const [oudeletionCheck, setOudeletionCheck] = useState(true);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(refreshToken());
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      fqdn: selectedNode.domainName,
      parentOu: selectedNode.selectedNode && selectedNode.selectedNode.name,
    });
  }, [selectedNode, form]);

  useEffect(() => {
    if (selectedNode.typeOfData === 'container') {
      Navigate('/');
    }
    if (selectedNode.typeOfData === 'domain') {
      Navigate('/create_parent_ou');
    }
  }, [location.pathname, selectedNode.typeOfData, Navigate]);

  const onFinish = async (values) => {
    values.parentOu = selectedNode.selectedNode.dnName;
    values.fqdn = selectedNode.domainName;
    values.accidentialDeletion = oudeletionCheck;
    try {
      setLoading(true);
      const sweetAlert = await dispatch(createChildOuData(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        const child = {
          ouName: values.newChildOuName,
          dnName: sweetAlert.payload.data.distinguishedName,
        };
        if (localStorage.getItem('role') === 'ouadmin') {
          dispatch(addOuInOuAdminTree({ ouAdminNodeKey, child }));
        } else {
          dispatch(addOuInAdminTree({ nodeKey, child }));
        }
        SweetSweetAlert({ sweetData: sweetAlert.payload.data.message, icon: 'success', buttonColor: 'green' });
        Navigate('/oudata');
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
    refreshOuTab();
  };

  const handleCountryChange = (selectedCountry) => {
    const selectedCountryData = Country.getAllCountries().find((country) => country.name === selectedCountry);

    if (selectedCountryData) {
      const selectedCountryStates = State.getStatesOfCountry(selectedCountryData.isoCode);
      setStates(selectedCountryStates);
    } else {
      setStates([]); // If the selected country is not found, clear the state options
    }
    // Clear the state field value
    form.setFieldsValue({ state: undefined });
  };
  return (
    <>
      <Createwrap className='af-outer-wrap af-create_child_ou-outer-wrap'>
        <CreateStyleDiv className='af-wrap af-create_child_ou-wrap'>
          <BackButton to='/oudata' className='af-back-button af-create_child_ou-back-button'>
            <LeftArrowIcon className='af-back-button-icon af-create_child_ou-back-button-icon' /> Back
          </BackButton>
          <CreateContendwrap className='af-content-wrap af-create_child_ou-content-wrap'>
            <CreateFormwrap className='af-form-wrap af-create_child_ou-form-wrap'>
              {loading && <ModalOpenLoader />}
              <FormHeader className='af-form-header af-create_child_ou-form-header'>Create Child OU</FormHeader>
              <Form
                className='af-form af-create_child_ou-form'
                form={form}
                layout='vertical'
                name='register'
                onFinish={onFinish}
                initialValues={{
                  parentOu: selectedNode.selectedNode && selectedNode.selectedNode.name,
                  newChildOuName: '',
                  description: '',
                  city: '',
                  state: null,
                  street: '',
                  postalCode: '',
                  country: null,
                }}
                scrollToFirstError
                size='large'
              >
                <RowWrapper className='af-form-row-wraper af-create_child_ou-form-row-wraper af-create_child_ou-form-row-wraper-wrap1'>
                  <FormItem
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-parentou'
                    key='parentOu'
                    name='parentOu'
                    label='Parent OU'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Parent OU `,
                      },
                    ]}
                  >
                    <Input
                      className='af-form-input af-create_child_ou-form-input af-create_child_ou-form-input_parentou'
                      disabled={true}
                    />
                  </FormItem>
                  <FormItem
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-childou'
                    key='newChildOuName'
                    name='newChildOuName'
                    label='Child OU'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Child OUName`,
                      },
                    ]}
                  >
                    <Input className='af-form-input af-create_child_ou-form-input af-create_child_ou-form-input_childou' />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-create_child_ou-form-row-wraper af-create_child_ou-form-row-wraper-wrap2'>
                  <FormItem
                    key='description'
                    name='description'
                    label='Description'
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-descrption'
                  >
                    <Input className='af-form-input af-create_child_ou-form-input af-create_child_ou-form-input_descrption' />
                  </FormItem>

                  <FormItem
                    key='country'
                    name='country'
                    label='Country'
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-country'
                  >
                    <Select
                      className='af-form-select af-create_child_ou-form-select af-create_child_ou-form-select_country'
                      showSearch
                      placeholder='Select a Country'
                      optionFilterProp='children'
                      onChange={handleCountryChange}
                      allowClear
                    >
                      {Country.getAllCountries().map((country) => (
                        <Select.Option
                          className='af-form-select-option af-create_child_ou-form-select-option af-create_child_ou-form-select-option_country'
                          key={country.isoCode}
                          value={country.name}
                        >
                          {country.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-create_child_ou-form-row-wraper af-create_child_ou-form-row-wraper-wrap3'>
                  <FormItem
                    key='state'
                    name='state'
                    label='State'
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-state'
                  >
                    <Select
                      className='af-form-select af-create_child_ou-form-select af-create_child_ou-form-select_state'
                      showSearch
                      allowClear
                      placeholder='Select a state'
                      optionFilterProp='children'
                    >
                      {states.map((state) => (
                        <Select.Option
                          className='af-form-select-option af-create_child_ou-form-select-option af-create_child_ou-form-select-option_state'
                          key={state.isoCode}
                          value={state.name}
                        >
                          {state.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </FormItem>
                  <FormItem
                    key='city'
                    name='city'
                    label='City'
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-city'
                  >
                    <Input className='af-form-input af-create_child_ou-form-input af-create_child_ou-form-input_city' />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-create_child_ou-form-row-wraper-wrap4'>
                  <FormItem
                    key='street'
                    name='street'
                    label='Street'
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-street'
                  >
                    <Input className='af-form-input af-create_child_ou-form-input af-create_child_ou-form-input_street' />
                  </FormItem>
                  <FormItem
                    key='postalCode'
                    name='postalCode'
                    label='Postal Code'
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-postalcode'
                  >
                    <Input className='af-form-input af-create_child_ou-form-input af-create_child_ou-form-input_postalcode' />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-create_child_ou-form-row-wraper af-create_child_ou-form-row-wraper-wrap5'>
                  <FormItem
                    className='af-form-item af-create_child_ou-form-item af-create_child_ou-form-item-acc_deletion'
                    key='accidentialDeletion'
                    name='accidentialDeletion'
                    label='Accidental Deletion'
                  >
                    <Checkbox
                      className='af-form-checkbox af-create_child_ou-form-checkbox af-create_child_ou-form-checkbox-acc_deletion'
                      checked={oudeletionCheck}
                      onChange={(e) => setOudeletionCheck(e.target.checked)}
                    >
                      Protect container from accidental deletion
                    </Checkbox>
                  </FormItem>
                </RowWrapper>
                <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-create_child_ou-form-button-submit-wrapper'>
                  <StyledButton
                    type='primary'
                    htmlType='submit'
                    className='af-form-button af-create_child_ou-form-button af-create_child_ou-form-button_submit'
                  >
                    Submit
                  </StyledButton>
                </FormSubmitButtonConatainer>
              </Form>
            </CreateFormwrap>
          </CreateContendwrap>
        </CreateStyleDiv>
      </Createwrap>
    </>
  );
}
